/**
 * PromisesQueue - Ensures async operations execute sequentially
 * 
 * Prevents race conditions by queueing promises and executing them one at a time.
 * If an operation fails, it logs the error but continues with the next operation.
 */
export class PromisesQueue {
  private queue: Array<() => Promise<void>> = [];
  private isProcessing = false;

  /**
   * Add a promise-returning function to the queue
   */
  add(fn: () => Promise<void>): void {
    this.queue.push(fn);
    if (!this.isProcessing) {
      this.dequeue();
    }
  }

  /**
   * Process the next item in the queue
   */
  private async dequeue(): Promise<void> {
    if (this.queue.length === 0) {
      this.isProcessing = false;
      return;
    }

    this.isProcessing = true;
    const fn = this.queue.shift();
    
    try {
      await fn?.();
    } catch (error) {
      console.error('[PromisesQueue] Task failed:', error);
    }

    // Continue with next item
    this.dequeue();
  }
}

